//////////// Asynchronously actions

////////////auth const begin here
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const CHECK_USER_LOGGED_SUCCESS = "CHECK_USER_LOGGED_SUCCESS";
export const CHECK_USER_LOGGED_FAILURE = "CHECK_USER_LOGGED_FAILURE";
export const GENERATE_USERNAME_SUCCESS = "GENERATE_USERNAME_SUCCESS";
export const GENERATE_USERNAME_FAILURE = "GENERATE_USERNAME_FAILURE";
export const GENERATE_PASSWORD_SUCCESS = "GENERATE_PASSWORD_SUCCESS";
export const GENERATE_PASSWORD_FAILURE = "GENERATE_PASSWORD_FAILURE";
////////////auth const end here

////////////request const begin here
export const REQUEST_ACCOUNT_SUCCESS = "REQUEST_ACCOUNT_SUCCESS";
export const REQUEST_ACCOUNT_FAILURE = "REQUEST_ACCOUNT_FAILURE";
export const GET_PENDING_REQUESTS_SUCCESS = "GET_PENDING_REQUESTS_SUCCESS";
export const GET_PENDING_REQUESTS_FAILURE = "GET_PENDING_REQUESTS_FAILURE";
export const GET_INPROGRESS_REQUESTS_SUCCESS =
  "GET_INPROGRESS_REQUESTS_SUCCESS";
export const GET_INPROGRESS_REQUESTS_FAILURE = "GET_INPROGRESS_REQUESTS_FAILURE";
export const GET_REQUEST_DETAILS_SUCCESS = "GET_REQUEST_DETAIL_SUCCESS";
export const GET_REQUEST_DETAILS_FAILURE = "GET_REQUEST_DETAIL_FAILURE";
export const REPLY_FOR_REQUEST_SUCCESS = "REPLY_FOR_REQUEST_SUCCESS";
export const REPLY_FOR_REQUEST_FAILURE = "REPLY_FOR_REQUEST_FAILURE";
export const CREATE_STUDENT_FROM_REQID_SUCCESS =
  "CREATE_STUDENT_FROM_REQID_SUCCESS";
export const CREATE_STUDENT_FROM_REQID_FAILURE =
  "CREATE_STUDENT_FROM_REQID_FAILURE";
  export const CREATE_GUEST_ACCOUNT_SUCCESS =
  "CREATE_GUEST_ACCOUNT_SUCCESS";
export const CREATE_GUEST_ACCOUNT_FAILURE =
  "CREATE_GUEST_ACCOUNT_FAILURE";
////////////request const end here

////////////Students const begin here
export const CREATE_PARENTAL_INFO_SUCCESS = "CREATE_PARENTAL_INFO_SUCCESS";
export const CREATE_PARENTAL_INFO_FAILURE = "CREATE_PARENTAL_INFO_FAILURE";
export const GET_STUDENTS_LIST_SUCCESS = "GET_STUDENTS_LIST_SUCCESS";
export const GET_STUDENTS_LIST_FAILURE = "GET_STUDENTS_LIST_FAILURE";
export const CREATE_STUDENT_PERSONAL_MANUALLY_SUCCESS = "CREATE_STUDENT_PERSONAL_MANUALLY_SUCCESS";
export const CREATE_STUDENT_PERSONAL_MANUALLY_FAILURE = "CREATE_STUDENT_PERSONAL_MANUALLY_FAILURE";
export const FIND_STUDENT_INFO_SUCCESS = "FIND_STUDENT_INFO_SUCCESS";
export const FIND_STUDENT_INFO_FAILURE = "FIND_STUDENT_INFO_FAILURE";
export const UPDATE_STUDENT_INFO_SUCCESS = "UPDATE_STUDENT_INFO_SUCCESS";
export const UPDATE_STUDENT_INFO_FAILURE = "UPDATE_STUDENT_INFO_FAILURE";
export const DELETE_STUDENT_SUCCESS = "DELETE_STUDENT_SUCCESS";
export const DELETE_STUDENT_FAILURE = "DELETE_STUDENT_FAILURE";
////////////Students const end here

///////////Teacher const begin here
export const CREATE_TEACHER_ACCOUNT_SUCCESS = "CREATE_TEACHER_ACCOUNT_SUCCESS";
export const CREATE_TEACHER_ACCOUNT_FAILURE = "CREATE_TEACHER_ACCOUNT_FAILURE";
export const GET_TEACHERS_LIST_SUCCESS = "GET_TEACHERS_LIST_SUCCESS";
export const GET_TEACHERS_LIST_FAILURE = "GET_TEACHERS_LIST_FAILURE";
export const FIND_TEACHER_INFO_SUCCESS = "FIND_TEACHER_INFO_SUCCESS";
export const FIND_TEACHER_INFO_FAILURE = "FIND_TEACHER_INFO_FAILURE";
export const UPDATE_TEACHER_INFO_SUCCESS = "UPDATE_TEACHER_INFO_SUCCESS";
export const UPDATE_TEACHER_INFO_FAILURE = "UPDATE_TEACHER_INFO_FAILURE";
export const DELETE_TEACHER_SUCCESS = "DELETE_TEACHER_SUCCESS";
export const DELETE_TEACHER_FAILURE = "DELETE_TEACHER_FAILURE";
//////////Teacher const end here

///////////Course const begin here
export const CREATE_COURSE_SUCCESS = "CREATE_COURSE_SUCCESS";
export const CREATE_COURSE_FAILURE = "CREATE_COURSE_FAILURE";
export const GET_COURSES_LIST_SUCCESS = "GET_COURSES_LIST_SUCCESS";
export const GET_COURSES_LIST_FAILURE = "GET_COURSES_LIST_FAILURE";
export const FIND_COURSE_SUCCESS = "FIND_COURSE_SUCCESS";
export const FIND_COURSE_FAILURE = "FIND_COURSE_FAILURE";
export const UPDATE_COURSE_SUCCESS = "UPDATE_COURSE_SUCCESS";
export const UPDATE_COURSE_FAILURE = "UPDATE_COURSE_FAILURE";
export const DELETE_COURSE_SUCCESS = "DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAILURE = "DELETE_COURSE_FAILURE";
///////////Course cosnt end here

///////////Class const begin here
export const CREATE_CLASS_SUCCESS = "CREATE_CLASS_SUCCESS";
export const CREATE_CLASS_FAILURE = "CREATE_CLASS_FAILURE";
export const FIND_CLASS_SUCCESS = "FIND_CLASS_SUCCESS";
export const FIND_CLASS_FAILURE = "FIND_CLASS_FAILURE";
export const UPDATE_CLASS_SUCCESS = "UPDATE_CLASS_SUCCESS";
export const UPDATE_CLASS_FAILURE = "UPDATE_CLASS_FAILURE";
export const DELETE_CLASS_SUCCESS = "DELETE_CLASS_SUCCESS";
export const DELETE_CLASS_FAILURE = "DELETE_CLASS_FAILURE";
export const FIND_WORKSHOP_SUCCESS = "FIND_WORKSHOP_SUCCESS";
export const FIND_WORKSHOP_FAILURE = "FIND_WORKSHOP_FAILURE";
export const GET_MY_WORKSHOPS_SUCCESS = "GET_MY_WORKSHOPS_SUCCESS";
export const GET_MY_WORKSHOPS_FAILURE = "GET_MY_WORKSHOPS_FAILURE";
export const UPDATE_WORKSHOP_SUCCESS = "UPDATE_WORKSHOP_SUCCESS";
export const UPDATE_WORKSHOP_FAILURE = "UPDATE_WORKSHOP_FAILURE";
export const DELETE_WORKSHOP_SUCCESS = "DELETE_WORKSHOP_SUCCESS";
export const DELETE_WORKSHOP_FAILURE = "DELETE_WORKSHOP_FAILURE";
export const FIND_CLASS_DETAIL_SUCCESS = "FIND_CLASS_DETAIL_SUCCESS";//public
export const FIND_CLASS_DETAIL_FAILURE = "FIND_CLASS_DETAIL_FAILURE";//public
export const GET_CLASSES_LIST_SUCCESS = "GET_CLASSES_LIST_SUCCESS";
export const GET_CLASSES_LIST_FAILURE = "GET_CLASSES_LIST_FAILURE";
export const GET_ALL_TYPE_OF_CLASSES_LIST_SUCCESS = "GET_ALL_TYPE_OF_CLASSES_LIST_SUCCESS";
export const GET_ALL_TYPE_OF_CLASSES_LIST_FAILURE = "GET_ALL_TYPE_OF_CLASSES_LIST_FAILURE";
export const GET_WORKSHOPS_LIST_SUCCESS = "GET_WORKSHOPS_LIST_SUCCESS";
export const GET_WORKSHOPS_LIST_FAILURE = "GET_WORKSHOPS_LIST_FAILURE";
export const ADD_STUDENTS_TO_CLASS_SUCCESS = "ADD_STUDENTS_TO_CLASS_SUCCESS";
export const ADD_STUDENTS_TO_CLASS_FAILURE = "ADD_STUDENTS_TO_CLASS_FAILURE";
export const ADD_STUDENT_TO_WORKSHOP_SUCCESS = "ADD_STUDENT_TO_WORKSHOP_SUCCESS";
export const ADD_STUDENT_TO_WORKSHOP_FAILURE = "ADD_STUDENT_TO_WORKSHOP_FAILURE";
export const FIND_STUDENTS_IN_CLASS_SUCCESS = "FIND_STUDENTS_IN_CLASS_SUCCESS";
export const FIND_STUDENTS_IN_CLASS_FAILURE = "FIND_STUDENTS_IN_CLASS_FAILURE";
export const FIND_STUDENTS_IN_WORKSHOP_SUCCESS = "FIND_STUDENTS_IN_WORKSHOP_SUCCESS";
export const FIND_STUDENTS_IN_WORKSHOP_FAILURE = "FIND_STUDENTS_IN_WORKSHOP_FAILURE";
export const GET_ATTENDANCE_IN_CLASS_SUCCESS =
  "GET_ATTENDANCE_IN_CLASS_SUCCESS";
export const GET_ATTENDANCE_IN_CLASS_FAILURE =
  "GET_ATTENDANCE_IN_CLASS_FAILURE";
  export const GET_ATTENDANCE_IN_WORKSHOP_SUCCESS =
  "GET_ATTENDANCE_IN_WORKSHOP_SUCCESS";
export const GET_ATTENDANCE_IN_WORKSHOP_FAILURE =
  "GET_ATTENDANCE_IN_WORKSHOP_FAILURE";
export const SUBMIT_ATTENDANCE_IN_CLASS_SUCCESS =
  "SUBMIT_ATTENDANCE_IN_CLASS_SUCCESS";
export const SUBMIT_ATTENDANCE_IN_CLASS_FAILURE =
  "SUBMIT_ATTENDANCE_IN_CLASS_FAILURE";
export const SUBMIT_ATTENDANCE_IN_WORKSHOP_SUCCESS =
  "SUBMIT_ATTENDANCE_IN_WORKSHOP_SUCCESS";
export const SUBMIT_ATTENDANCE_IN_WORKSHOP_FAILURE =
  "SUBMIT_ATTENDANCE_IN_WORKSHOP_FAILURE";
export const TRANSFER_STUDENT_TO_CLASS_SUCCESS = "TRANSFER_STUDENT_TO_CLASS_SUCCESS";
export const TRANSFER_STUDENT_TO_CLASS_FAILURE = "TRANSFER_STUDENT_TO_CLASS_FAILURE";
///////////Class cosnt end here

///////////Schedule Course const begin here
export const CREATE_SCHEDULE_COURSE_SUCCESS = "CREATE_SCHEDULE_COURSE_SUCCESS";
export const CREATE_SCHEDULE_COURSE_FAILURE = "CREATE_SCHEDULE_COURSE_FAILURE";
export const GET_SCHEDULE_COURSES_LIST_SUCCESS =
  "GET_SCHEDULE_COURSES_LIST_SUCCESS";
export const GET_SCHEDULE_COURSES_LIST_FAILURE =
  "GET_SCHEDULE_COURSES_LIST_FAILURE";
export const FIND_SCHEDULED_COURSE_SUCCESS =
  "FIND_SCHEDULED_COURSE_SUCCESS";
export const FIND_SCHEDULED_COURSE_FAILURE =
  "FIND_SCHEDULED_COURSE_FAILURE";
export const UPDATE_SCHEDULED_COURSE_SUCCESS =
  "UPDATE_SCHEDULED_COURSE_SUCCESS";
export const UPDATE_SCHEDULED_COURSE_FAILURE =
  "UPDATE_SCHEDULED_COURSE_FAILURE";
export const DELETE_SCHEDULED_COURSE_SUCCESS =
  "DELETE_SCHEDULED_COURSE_SUCCESS";
export const DELETE_SCHEDULED_COURSE_FAILURE =
  "DELETE_SCHEDULED_COURSE_FAILURE";
///////////Schedule course cosnt end here

//////////SCHEDULES const begin here
export const FIND_SCHEDULES_SUCCESS = "FIND_SCHEDULES_SUCCESS";
export const FIND_SCHEDULES_FAILURE = "FIND_SCHEDULES_FAILURE";
export const FIND_SCHEDULES_FOR_RESPONSIBLE_STUDENTS_SUCCESS = "FIND_SCHEDULES_FOR_RESPONSIBLE_STUDENTS_SUCCESS";
export const FIND_SCHEDULES_FOR_RESPONSIBLE_STUDENTS_FAILURE = "FIND_SCHEDULES_FOR_RESPONSIBLE_STUDENTS_FAILURE";
/////////SCHEDULES const end here

/////////PAYMENT const begin here
export const GET_STUDENT_PAYMENT_SUCCESS = "GET_STUDENT_PAYMENT_SUCCESS"
export const GET_STUDENT_PAYMENT_FAILURE = "GET_STUDENT_PAYMENT_FAILURE"
export const CREATE_STUDENT_PAYMENT_SUCCESS = "CREATE_STUDENT_PAYMENT_SUCCESS"
export const CREATE_STUDENT_PAYMENT_FAILURE = "CREATE_STUDENT_PAYMENT_FAILURE"
export const FIND_STUDENT_PAYMENT_SUCCESS = "FIND_STUDENT_PAYMENT_SUCCESS"
export const FIND_STUDENT_PAYMENT_FAILURE = "FIND_STUDENT_PAYMENT_FAILURE"
export const UPDATE_STUDENT_PAYMENT_SUCCESS = "UPDATE_STUDENT_PAYMENT_SUCCESS"
export const UPDATE_STUDENT_PAYMENT_FAILRUE = "UPDATE_STUDENT_PAYMENT_FAILRUE"
export const DELETE_STUDENT_PAYMENT_SUCCESS = "DELETE_STUDENT_PAYMENT_SUCCESS"
export const DELETE_STUDENT_PAYMENT_FAILURE = "DELETE_STUDENT_PAYMENT_FAILURE"
export const GET_ALL_PAYMENTS_STUDENT_LIST_SUCCESS = "GET_ALL_PAYMENTS_STUDENT_LIST_SUCCESS"
export const GET_ALL_PAYMENTS_STUDENT_LIST_FAILURE = "GET_ALL_PAYMENTS_STUDENT_LIST_FAILURE"
export const GET_TEACHER_PAYMENT_SUCCESS = "GET_TEACHER_PAYMENT_SUCCESS"
export const GET_TEACHER_PAYMENT_FAILURE = "GET_TEACHER_PAYMENT_FAILURE"
export const CREATE_TEACHER_PAYMENT_SUCCESS = "CREATE_TEACHER_PAYMENT_SUCCESS"
export const CREATE_TEACHER_PAYMENT_FAILURE = "CREATE_TEACHER_PAYMENT_FAILURE"
export const FIND_TEACHER_PAYMENT_SUCCESS = "FIND_TEACHER_PAYMENT_SUCCESS"
export const FIND_TEACHER_PAYMENT_FAILURE = "FIND_TEACHER_PAYMENT_FAILURE"
export const UPDATE_TEACHER_PAYMENT_SUCCESS = "UPDATE_TEACHER_PAYMENT_SUCCESS"
export const UPDATE_TEACHER_PAYMENT_FAILRUE = "UPDATE_TEACHER_PAYMENT_FAILRUE"
export const DELETE_TEACHER_PAYMENT_SUCCESS = "DELETE_TEACHER_PAYMENT_SUCCESS"
export const DELETE_TEACHER_PAYMENT_FAILURE = "DELETE_TEACHER_PAYMENT_FAILURE"
export const GET_ALL_PAYMENTS_TEACHER_LIST_SUCCESS = "GET_ALL_PAYMENTS_TEACHER_LIST_SUCCESS"
export const GET_ALL_PAYMENTS_TEACHER_LIST_FAILURE = "GET_ALL_PAYMENTS_TEACHER_LIST_FAILURE"

////////PERMISSIONS const begin here
export const CREATE_PERMISSION_SUCCESS = "CREATE_PERMISSION_SUCCESS"
export const CREATE_PERMISSION_FAILURE = "CREATE_PERMISSION_FAILURE"
export const GET_ALL_PERMISSIONS_SUCCESS = "GET_ALL_PERMISSIONS_SUCCESS"
export const GET_ALL_PERMISSIONS_FAILURE = "GET_ALL_PERMISSIONS_FAILURE"
export const FIND_PERMISSION_SUCCESS = "FIND_PERMISSION_SUCCESS"
export const FIND_PERMISSION_FAILURE = "FIND_PERMISSION_FAILURE"
export const FIND_ROLE_SUCCESS = "FIND_ROLE_SUCCESS"
export const FIND_ROLE_FAILURE = "FIND_ROLE_FAILURE"
export const UPDATE_PERMISSION_SUCCESS = "UPDATE_PERMISSION_SUCCESS"
export const UPDATE_PERMISSION_FAILURE = "UPDATE_PERMISSION_FAILURE"
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS"
export const UPDATE_ROLE_FAILURE = "UPDATE_ROLE_FAILURE"
export const DELETE_PERMISSION_SUCCESS = "DELETE_PERMISSION_SUCCESS"
export const DELETE_PERMISSION_FAILURE = "DELETE_PERMISSION_FAILURE"
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS"
export const DELETE_ROLE_FAILURE = "DELETE_ROLE_FAILURE"
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS"
export const CREATE_ROLE_FAILURE = "CREATE_ROLE_FAILURE"
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS"
export const GET_ALL_ROLES_FAILURE = "GET_ALL_ROLES_FAILURE"
export const ADD_PERMISSION_TO_ROLE_SUCCESS = "ADD_PERMISSION_TO_ROLE_SUCCESS"
export const ADD_PERMISSION_TO_ROLE_FAILURE = "ADD_PERMISSION_TO_ROLE_FAILURE"


////////////// Assignments actions
export const SUBMIT_GRADE_REPLY_ASSIGNMENT_SUCCESS = "SUBMIT_GRADE_REPLY_ASSIGNMENT_SUCCESS"
export const SUBMIT_GRADE_REPLY_ASSIGNMENT_FAILURE = "SUBMIT_GRADE_REPLY_ASSIGNMENT_FAILURE"
export const CREATE_ASSIGNMENT_SUCCESS = "CREATE_ASSIGNMENT_SUCCESS"
export const CREATE_ASSIGNMENT_FAILURE = "CREATE_ASSIGNMENT_FAILURE"
export const GET_ASSIGNMENTS_LIST_SUCCESS = "GET_ASSIGNMENTS_LIST_SUCCESS"
export const GET_ASSIGNMENTS_LIST_FAILURE = "GET_ASSIGNMENTS_LIST_FAILURE"
export const FIND_ASSIGNMENT_SUCCESS = "FIND_ASSIGNMENT_SUCCESS"
export const FIND_ASSIGNMENT_FAILURE = "FIND_ASSIGNMENT_FAILURE"
export const UPDATE_ASSIGNMENT_SUCCESS = "UPDATE_ASSIGNMENT_SUCCESS"
export const UPDATE_ASSIGNMENT_FAILURE = "UPDATE_ASSIGNMENT_FAILURE"
export const DELETE_ASSIGNMENT_SUCCESS = "DELETE_ASSIGNMENT_SUCCESS"
export const DELETE_ASSIGNMENT_FAILURE = "DELETE_ASSIGNMENT_FAILURE"
export const SUBMIT_REPLY_ASSIGNMENT_SUCCESS = "SUBMIT_REPLY_ASSIGNMENT_SUCCESS"
export const SUBMIT_REPLY_ASSIGNMENT_FAILURE = "SUBMIT_REPLY_ASSIGNMENT_FAILURE"
export const SUBMIT_ANSWER_ASSIGNMENT_SUCCESS = "SUBMIT_ANSWER_ASSIGNMENT_SUCCESS"
export const SUBMIT_ANSWER_ASSIGNMENT_FAILURE = "SUBMIT_REPLY_ASSIGNMENT_FAILURE"
export const VIEW_REPLIES_ASSIGNMENT_SUCCESS = "VIEW_REPLIES_ASSIGNMENT_SUCCESS"
export const VIEW_REPLIES_ASSIGNMENT_FAILURE = "VIEW_REPLIES_ASSIGNMENT_FAILURE"
export const FIND_ASSIGNMENTS_HOMEOWRK_SUCCESS = "FIND_ASSIGNMENTS_HOMEOWRK_SUCCESS"
export const FIND_ASSIGNMENTS_HOMEOWRK_FAILURE = "FIND_ASSIGNMENTS_HOMEOWRK_FAILURE"

//////////// Synchronous actions
export const LOGOUT = "LOGOUT";
export const GET_MESSAGE = "GET_MESSAGE";
export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
